import {
  matchExpression as genericMatchExpression,
  type ExpressionMatcher,
  type PartialExpressionMatcher,
} from './GenericExpression/GenericMatchExpression';

import {type Expression} from '@packages/systems/wfdl-ast';

export const matchExpression = <o>(
  matchers:
    | ExpressionMatcher<Expression, o>
    | PartialExpressionMatcher<Expression, o>
) => genericMatchExpression<Expression, o>(matchers);
